import Colors from "../constants/colors";

const theme = {
  roundness: 4,
  spacing: 8,
  borderThickness: 2,

  colors: Colors.light,
};

export default theme;
